import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { LinkExpirationComponent } from './link-expiration.component';

@NgModule({
  declarations: [
    LinkExpirationComponent
  ],
  imports: [
    CommonModule,
    ProgressBarModule,
  ],
  exports: [
    LinkExpirationComponent
  ]
})
export class LinkExpirationModule { }